import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { GuestGuard } from 'src/guards/guest-guard';
import { AuthLayout } from 'src/layouts';

const LoginPage = lazy(() => import('src/pages/auth/login'));
const RegisterPage = lazy(() => import('src/pages/auth/register'));

export const authRoutes: RouteObject[] = [
  {
    path: 'login',
    element: (
      <GuestGuard>
        <AuthLayout>
          <LoginPage />
        </AuthLayout>
      </GuestGuard>
    )
  }
  // {
  //   path: 'signup',
  //   element: (
  //     <GuestGuard>
  //       <AuthLayout>
  //         <RegisterPage />
  //       </AuthLayout>
  //     </GuestGuard>
  //   )
  // }
];
